import Goal1 from "./icons/icon1.svg";
import Goal2 from "./icons/icon2.svg";
import Goal3 from "./icons/icon3.svg";
import Goal4 from "./icons/icon4.svg";
import Goal5 from "./icons/icon5.svg";
import Goal6 from "./icons/icon6.svg";
import Goal7 from "./icons/icon7.svg";
import Goal8 from "./icons/icon8.svg";
import Goal9 from "./icons/icon9.svg";
import Goal10 from "./icons/icon10.svg";
import Goal11 from "./icons/icon11.svg";
import Goal12 from "./icons/icon12.svg";
import Goal13 from "./icons/icon13.svg";
import Goal14 from "./icons/icon14.svg";
import Goal15 from "./icons/icon15.svg";
import Goal16 from "./icons/icon16.svg";
import Goal17 from "./icons/icon17.svg";

interface SdgGoalProps {
  goal: number;
}

function SdgGoal({ goal }: SdgGoalProps) {
  const goals = [
    Goal1,
    Goal2,
    Goal3,
    Goal4,
    Goal5,
    Goal6,
    Goal7,
    Goal8,
    Goal9,
    Goal10,
    Goal11,
    Goal12,
    Goal13,
    Goal14,
    Goal15,
    Goal16,
    Goal17,
  ];
  return (
    <img className="w-14 h-14" src={goals[goal - 1]} alt={`Goal ${goal}`} />
  );
}

export default SdgGoal;
